import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, ButtonContainer, EditableDataGrid, GridItem, GridRow, Icon, IconButton, Spacer, TextField, Typography } from '@emburse/embark-core';
import { AddIcon, CancelCircle, CheckIcon, EditIcon } from '@emburse/embark-icons';
import { DeleteOutline } from '@mui/icons-material';
import { debounce } from 'lodash';
import DataGridLoading from '../../../../views/QuickSetup/components/DataGridLoading';
import { $t, useTranslation } from '../../../../hooks/useTranslation';
import { generateRandomGUID } from '../../../../util/helpers';
import { defaultValidation } from '../../../../util/formValidation';
function GLDDataTable({ tableData, label, loading, index, updateTableData, updateLabel }) {
    useTranslation();
    const [isEditingLabel, setIsEditingLabel] = useState(false);
    const [newLabel, setNewLabel] = useState('');
    const addRow = () => {
        const tableDataCopy = JSON.parse(JSON.stringify(tableData));
        tableDataCopy.unshift({
            id: generateRandomGUID(),
            Name: '',
            Code: '',
            Data: ''
        });
        updateTableData(tableDataCopy);
    };
    const rowChangeHandler = (row) => {
        let tableDataCopy = JSON.parse(JSON.stringify(tableData));
        tableDataCopy = tableDataCopy.map((tRow) => (tRow.id === row.id ? row : tRow));
        updateTableData(tableDataCopy);
    };
    const deleteRow = (id) => {
        const tableDataCopy = JSON.parse(JSON.stringify(tableData));
        const tableRow = tableDataCopy.findIndex((row) => row.id === id);
        tableDataCopy.splice(tableRow, 1);
        updateTableData(tableDataCopy);
    };
    const moreActionsMenu = (params) => ({
        sections: [
            {
                items: [
                    {
                        iconText: 'Delete',
                        closeOnClick: true,
                        icon: _jsx(DeleteOutline, {}),
                        onClick: () => deleteRow(params.row.id)
                    }
                ]
            }
        ]
    });
    const rowValidation = (row) => {
        const nameInvalid = defaultValidation(row.Name);
        const name = nameInvalid.length && { field: 'Name', reason: nameInvalid };
        return [name];
    };
    const saveRow = async (id, row) => {
        const invalid = rowValidation(row).every((item) => !!item);
        // TEditableDGError
        if (invalid) {
            return {
                success: false,
                error: rowValidation(row)
            };
        }
        rowChangeHandler(row);
        return { success: true };
    };
    const preProcessCells = async (params) => {
        if (!params.hasChanged) {
            return { ...params.props };
        }
        const invalid = defaultValidation(params.props.value);
        return { ...params.props, error: invalid.length ? invalid : false };
    };
    const updateNewLabel = debounce((e) => {
        setNewLabel(e.target.value);
    }, 50);
    return (_jsxs(_Fragment, { children: [_jsx(GridRow, { children: _jsx(GridItem, { children: !isEditingLabel ? (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h5", display: "inline", children: label ? $t(label) : `Dimension ${index + 1}` }), _jsx(IconButton, { size: "medium", title: "Save Name", onClick: () => setIsEditingLabel(true), style: {
                                    verticalAlign: 'sub',
                                    marginLeft: '6px'
                                }, children: _jsx(Icon, { iconUrl: EditIcon }) })] })) : (_jsxs(_Fragment, { children: [_jsx(TextField, { label: "", defaultValue: label, onChange: updateNewLabel }), _jsx(IconButton, { size: "medium", title: "Save Name", onClick: () => {
                                    updateLabel(newLabel, index);
                                    setIsEditingLabel(false);
                                    setNewLabel('');
                                }, children: _jsx(Icon, { iconUrl: CheckIcon }) }), _jsx(IconButton, { size: "medium", title: "Close Editing Label", onClick: () => {
                                    setIsEditingLabel(false);
                                    setNewLabel('');
                                }, children: _jsx(Icon, { iconUrl: CancelCircle }) })] })) }) }), _jsx(Spacer, { size: 35 }), _jsx(ButtonContainer, { alignButtons: "right", sx: { position: 'relative' }, children: _jsx(Button, { variant: "text", size: "small", onClick: addRow, endIcon: _jsx(Icon, { iconUrl: AddIcon }), style: {
                        position: 'absolute',
                        zIndex: 99,
                        right: 0,
                        top: '12px'
                    }, children: $t('Add Row') }) }), _jsx(EditableDataGrid, { autoHeight: true, pageSizeOptions: [5, 10, 100], localeText: { noRowsLabel: '' }, rows: tableData, hideOnSaveSuccessSnackbar: true, generateMoreActionsMenu: (params) => moreActionsMenu(params), onSave: saveRow, columns: [
                    {
                        field: 'Name',
                        headerName: $t('Name'),
                        flex: 4,
                        editable: true,
                        type: 'string',
                        preProcessEditCellProps: preProcessCells
                    },
                    {
                        field: 'Code',
                        headerName: $t('Code'),
                        flex: 4,
                        editable: true,
                        type: 'string'
                    },
                    {
                        field: 'Data',
                        headerName: $t('Data'),
                        flex: 4,
                        editable: true,
                        type: 'string'
                    }
                ] }), loading && _jsx(DataGridLoading, {})] }));
}
GLDDataTable.defaultProps = {
    showCancel: true
};
export default GLDDataTable;
